import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { axiom } from './axiom';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatMilitaryTime(date: Date = new Date()): string {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }) + ' GST';
}

export function formatDate(date: Date = new Date()): string {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

export function formatTime(date: Date = new Date()): string {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

/**
 * Safely parse JSON, returning a fallback value on error.
 * Prevents malformed DB data from crashing the entire history load.
 */
export function safeJsonParse<T>(json: string | null | undefined, fallback: T): T {
  if (!json) return fallback;
  try {
    return JSON.parse(json) as T;
  } catch {
    // Truncate large payloads to avoid flooding logs with sensitive data
    const preview = json.length > 100 ? json.slice(0, 100) + '...' : json;
    axiom.warn('Failed to parse JSON', { json_preview: preview });
    return fallback;
  }
}
